import React, { useRef, useState } from "react"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import timeGridPlugin from "@fullcalendar/timegrid"
import ptBrlLocale from "@fullcalendar/core/locales/pt-br"
import "@fullcalendar/core/"
import "@fullcalendar/timegrid/main.css"
import moment from "moment"
import { CirclePickerColor } from "../../components/ColorPicker"
import { CalendarDatePicker } from "../../components/DatePicker"
import { optionsEvents } from "../../core/mocks/calendar/options"
import { Button, ButtonLoader } from "../../components/Button"
import { isMobile } from "react-device-detect"
import {
  Input,
  TextArea,
  FormRow,
  Label,
  SelectInput,
} from "../../components/Form"
import {
  ModalBody,
  ModalDouble,
  ModalFooter,
  ModalHeader,
  ModalPanel,
} from "../../components/Modal"
import ScheduledEvents from "../../components/SheduledEvents"
import ModalAlert from "../../components/ModalAlert"
import NewsContentSend from "../../container/MessageNewsCalendarContainer"
import "./styles.scss"

const CalendarScreen = ({
  register,
  errors,
  eventClickInfo,
  modalIsOpen,
  closeModal,
  handleRemoveEvent,
  handleEventClick,
  setColorEvent,
  handleChangeOptionsEvent,
  selectedOption,
  selectedPosts,
  setSelectedPosts,
  setAllPosts,
  typeEvent,
  handleDateSelect,
  setCurrentDateOnClick,
  currentDateOnClick,
  eventsDate,
  calendarEvents,
  formatCurrentDateClicked,
  loading,
  loadingRemove,
  handleSubmit,
  tagsProject,
  onChange,
  typeEventTrail,
  typeEventTrailOrContent,
  typeEventSector,
  typeEventContent,
  tagsToEventProject,
  selectedProject,
  projectsByScope,
  handleChangeProject
}) => {
  const calendarRef = useRef(null)

  const [showAutoModal, setShowAutoModal] = useState(false)

  moment.updateLocale("pt-Br", {
    week: {
      dow: 1, // Monday is the first day of the week.
    },
  })

  const optionsCalendar =
    typeEventTrailOrContent || eventClickInfo.state == "create"
      ? optionsEvents.filter((item) => item.description !== "Mudança de setor")
      : optionsEvents


  return (
    <>
      <div className="fullcalendar">
        <div className="fullcalendar-content">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
            timeZone="UTC"
            ignoreTimezone={true}
            locale={ptBrlLocale}
            displayEventTime={true}
            eventResize={false}
            customButtons={{
              myCustomButton: {
                text: "+ Evento",
                click: handleDateSelect,
              },
            }}
            headerToolbar={{
              start: "prev, title, next",
              right: "myCustomButton, dayGridMonth, timeGridWeek",
            }}
            eventClick={handleEventClick}
            editable={true}
            events={calendarEvents}
            dateClick={handleDateSelect}
            selectable={true}
            selectHelper={true}
            dayMaxEventRows={true}
            views={{
              dayGridMonth: {
                dayMaxEventRows: 3,
                dayHeaderContent: (args) => {
                  const days = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]
                  return <span className="date-week">{days[args.date.getDay()]}</span>
                },
              },
              timeGridWeek: {
                titleFormat: { year: "numeric", month: "short" },
                dayHeaderContent: (args) => {
                  const days = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]
                  return (
                    <div className="c-week-format">
                      <span className="date-day">{days[args.date.getDay()]}</span>
                      <div
                        class={`date-week ${moment(args.date).add(1, "d").format("DD") ==
                          currentDateOnClick.getDate() &&
                          moment(args.date).format("M") === moment(new Date()).format("M") &&
                          "date-day--current"
                          }`}>
                        {moment(args.date).add(1, "d").format("DD")}
                      </div>
                    </div>
                  )
                },
              },
            }}
            eventHint="#000"
            eventClassNames="event-calendar"
            rerenderDelay={1}
            goToDate={formatCurrentDateClicked}
          //datesSet={(arg) => setTypeView(arg.view.type)}
          />
        </div>
        {isMobile ? (
          <></>
        ) : (
          <div className="date-picker-container">
            <CalendarDatePicker setCurrentDateOnClick={setCurrentDateOnClick} calendarRef={calendarRef} />
            <ScheduledEvents
              items={eventsDate}
              setCurrentDateOnClick={setCurrentDateOnClick}
              handleEventClick={handleEventClick}
              calendarRef={calendarRef}
            />
          </div>)}
      </div>
      <ModalPanel modalIsOpen={modalIsOpen}>
        {isMobile ? (
          <> <div className="new-register-header">
            <div className="form-header">
              <div style={{ display: "flex", gap: "10px" }}>
                <button className="button-back" onClick={() => closeModal()}>
                  <i className="fi fi-sr-arrow-small-left" />
                </button>
                <span>{eventClickInfo.state == "create" ? "Criar Evento" : "Alterar Evento"}</span>
              </div>
            </div>
          </div>
          </>
        ) : (
          <ModalHeader
            closeModal={() => closeModal()}
            title={
              eventClickInfo.state == "create" ? "Criar Evento" : "Alterar Evento"
            }></ModalHeader>)}
        <ModalBody>
          <div className="modal-double-calendar">
            <ModalDouble position={"left"}>
              <div className="form-group-box-date">
                <FormRow>
                  <Label label="Titulo do Evento" hasError={errors.title?.message} />
                  <Input
                    placeholder="Titulo do Evento"
                    register={register("title", {
                      required: { value: true, message: "Campo Obrigatório" },
                    })}
                    hasError={errors.title?.message}
                  />
                </FormRow>
                <FormRow>
                  <Label label="Tipo do Evento" />
                  <SelectInput
                    value={selectedOption || typeEvent}
                    placeholder={"Selecione um Tipo" || typeEvent}
                    options={optionsCalendar.map(({ id, description }) => ({
                      value: id,
                      label: description,
                    }))}
                    onChange={handleChangeOptionsEvent}
                    isDisabled={typeEventSector}
                    hasError={typeEventSector && "Este campo não pode ser alterado"}
                  />
                </FormRow>
                <FormRow>
                  <Label label="Projeto" />
                  <SelectInput
                    value={selectedProject}
                    defaultValue={selectedProject}
                    placeholder="Selecione um projeto"
                    options={projectsByScope && projectsByScope.map(({ id, description }) => ({
                      value: id,
                      label: description,
                    }))}
                    onChange={handleChangeProject}
                  />
                </FormRow>
                {typeEventContent && (
                  <div className="events-box">
                    <Button
                      label={
                        selectedPosts?.length
                          ? `Ver ${selectedPosts?.length} Contéudos Selecionados`
                          : "Selecionar Conteúdos"
                      }
                      handleClick={() => setShowAutoModal((prev) => !prev)}
                    //isDisabled={watch("recurrence")}
                    />
                  </div>
                )}
                {typeEventTrail && (
                  <FormRow className="content-recurrent">
                    <Label label="Recorrência" />
                    <Input
                      type="number"
                      register={register("recurrence")}
                      placeholder="Digite o dia de recorrência dos envios"
                      hasError={errors.recurrence?.message}
                    />
                  </FormRow>
                )}
                <FormRow>
                  <Label label="Descrição do Evento" />
                  <TextArea
                    placeholder={"Descrição do Evento"}
                    register={register("description")}
                    resize="none"
                  />
                </FormRow>
              </div>
            </ModalDouble>
            <ModalDouble position={"right"}>
              <div className="form-group-box-date">
                <div className="form-box">
                  <div className="form-date">
                    <Label label={`${!typeEventSector ? "Data de Inicio" : "Data"}`} />
                    <Input type="date" register={register("start")} />
                  </div>
                  {!typeEventSector && <div className="form-date">
                    <Label label="Data de Término" />
                    <Input type="date" register={register("end")} isDisabled={typeEventSector} />
                  </div>}
                </div>
                {!typeEventContent && !typeEventTrail && !typeEventSector && (
                  <div className="form-box">
                    <div className="form-date">
                      <Label label="Hora de Início" hasError={errors.start_time?.message} />
                      <Input
                        type="time"
                        register={register("start_time", {
                          required: { value: true, message: "Campo Obrigatório" },
                        })}
                        hasError={errors.start_time?.message}
                      />
                    </div>
                    <div className="form-date">
                      <Label label="Hora de Término" />
                      <Input type="time" register={register("end_time")} />
                    </div>
                  </div>
                )}
                {showAutoModal && (
                  <NewsContentSend
                    openModalContent={showAutoModal}
                    {...{
                      selectedPosts,
                      setSelectedPosts,
                      setAllPosts,
                      setShowAutoModal,
                      showAutoModal,
                    }}
                  />
                )}
                {typeEventTrailOrContent && (
                  <FormRow>
                    <Label label="Tags do Projeto" />
                    <SelectInput
                      isMulti={tagsProject && tagsProject?.length > 0}
                      placeholder={"Selecione as tags do projeto"}
                      options={tagsProject?.map(({ id, name }) => ({
                        value: id,
                        label: name,
                      }))}
                      isSearchable
                      onChange={onChange("tags")}
                      name="tags"
                      defaultValue={tagsToEventProject.tags}
                    />
                  </FormRow>
                )}
                {/* {typeEventSector && (
                  <>
                    <FormRow>
                      <Label label="Usuários do Evento" />
                      <SelectInput
                        name="usersEvent"
                        placeholder="Selecione um usuário"
                        options={users.map(({ id, name }) => ({
                          value: id,
                          label: name,
                        }))}
                        isMulti={users && users.length > 0}
                        control={control}
                        isRequired
                        isSearchable
                        onChange={onChange("userEvent")}
                        defaultValue={tagsUsers?.users}
                      />
                    </FormRow>
                    <FormRow>
                      <Label label="Tags do Evento" />
                      <SelectInput
                        name="tagsEvent"
                        placeholder="Selecione uma tag"
                        options={tagsProject?.map(({ id, name }) => ({
                          value: id,
                          label: name,
                        }))}
                        control={control}
                        isRequired
                        isSearchable
                        isMulti={tagsProject && tagsProject?.length > 0}
                        hasError={errors.tagsEvent?.message && "Selecione pelo menos uma tag"}
                        defaultValue={tagsUsers?.users}
                      />
                    </FormRow>
                  </>
                )} */}
                <FormRow className="form-box-colors">
                  <Label label="Selecione uma cor de identificação" />
                  <CirclePickerColor handleChangeColor={(color) => setColorEvent(color.hex)} />
                </FormRow>
              </div>
            </ModalDouble>
          </div>
        </ModalBody>
        <ModalFooter>
          {eventClickInfo.state !== "create" && (
            <ButtonLoader
              type="submit"
              handleClick={() =>
                ModalAlert.danger({
                  title: "Deseja mesmo remover este evento?",
                  confirmLabel: "Excluir",
                  onConfirm: handleRemoveEvent,
                })
              }
              loading={loadingRemove}
              label="Excluir Evento"
              messageProcess="Excluindo"
              color="danger"
            />
          )}
          <ButtonLoader
            handleClick={handleSubmit}
            label={eventClickInfo.state === "create" ? "Salvar" : "Alterar"}
            color="orange"
            isDisabled={loading || (typeEventContent && !selectedPosts.length)}
            messageProcess="Salvando"
            loading={loading}
          />
        </ModalFooter>
      </ModalPanel>
    </>
  )
}

export default CalendarScreen
